// extracted by mini-css-extract-plugin
export default {"price-section":"price-section-0445","price":"price-81e8","divider":"divider-4654","month":"month-bc35","medium":"medium-2494","small":"small-8560","regularText":"regularText-aa26"};